import { cva } from 'class-variance-authority';

const img = cva(['object-cover'], {
  variants: {
    size: {
      8: 'h-8 w-8',
      10: 'h-10 w-10',
      12: 'h-12 w-12',
      16: 'h-16 w-16',
    },
    rounded: {
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      full: 'rounded-full',
    },
  },
});

export default function KoobAvatar({
  className,
  src,
  alt = '',
  size = 10,
  rounded = 'md',
}: {
  className?: string;
  src: string;
  alt?: string;
  size?: 8 | 10 | 12 | 16;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}) {
  return (
    <img
      className={[img({ size, rounded }), className].join(' ')}
      src={src}
      alt={alt}
    />
  );
}
